import { EmptyState, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledEmptyState = styled(EmptyState) `
  padding-left: ${themeGet('spacing.xl')};
  padding-right: ${themeGet('spacing.xl')};
`;
